import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';

import CoreLayout from './layouts/PageLayout/PageLayout';
import ViewOfficeHoursRoute from './routes/ViewOfficeHours';
import JoinSessionRoute from './routes/JoinPage/';

export const createRoutes = (store) => {
  return ({
    path        : 'signup/virtualteatime',
    component   : props => {
      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer unauthed',
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    },
    indexRoute  : ViewOfficeHoursRoute(store),
    childRoutes : [
      JoinSessionRoute(store),
    ],
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/officehours/index.js